export const INVOICE_TYPE = {
  TAKE_AWAY: "Take Away",
  DINE: "Dine",
  DELIVERY: "Delivery",
};
